import './ItemCardFactory.css';

import React from "react";
import ItemFileCard from "./files/ItemFileCard";
import ItemNoteCard from './notes/ItemNoteCard';
import ItemLinkCard from './links/ItemLinkCard';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const ItemCardFactory = ({ item, onClick, onEdit, onDelete }) => {
    const { t } = useB2BTranslation('b2b-logbook');

    switch (item.logBookItemType) {
        case 'FILE':
            return (
                <ItemFileCard
                    item={item}
                    onClick={onClick}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            );
        case 'NOTE':
            return (
                <ItemNoteCard
                    item={item}
                    onClick={onClick}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            );
        case 'LINK':
            return (
                <ItemLinkCard
                    item={item}
                    onClick={onClick}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            );
        default:
            return (
                <div className='unknown-item-card'>
                    {t('Unknown item type')}
                </div>
            )
    }
}

export default ItemCardFactory;